export default "../css/f69e43267ec300690c7c4187bdabaec8.ttf";